import React from "react";
import "./BottomModal.scss";
import {MDBModal, MDBModalBody, MDBModalFooter, MDBModalHeader} from "mdbreact";

class BottomModal extends React.Component{
    render() {
        return(
            <div className={`bottom-modal-component ${this.props.setBackground === true?"modal-background":""}`}>
                <MDBModal  isOpen={this.props.isOpen} toggle={this.props.closeModal} fullHeight position="bottom" >
	                {
	                	this.props.removeHeader === false &&
		                <MDBModalHeader  toggle={this.props.closeModal} className={this.props.hideBorder?"modal-title border-hidden":"modal-title"}>{this.props.title}</MDBModalHeader>
	                }

                    <MDBModalBody>
                        {this.props.children}
                    </MDBModalBody>
                    {
                        this.props.footer &&
                        <MDBModalFooter>
                            {this.props.footerComponent}
                        </MDBModalFooter>
                    }

                </MDBModal>
            </div>
        );
    }
}

export default BottomModal;